import { render } from "./showLotComponent.vue?vue&type=template&id=64a77f0f"
import script from "./showLotComponent.vue?vue&type=script&lang=js"
export * from "./showLotComponent.vue?vue&type=script&lang=js"

import "./showLotComponent.vue?vue&type=style&index=0&id=64a77f0f&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__